export default "__VITE_ASSET__C2L9sL91__"